import { useState } from 'react';
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { storeAreYouSureModalCallback } from '../redux/reducers/authSlice';

interface Props {
    isShown: boolean
    onClose: (() => void) | undefined
}

const AreYouSureModal = ({ isShown, onClose }: Props) => {
    const dispatch = useDispatch();
    const [deviceNo, setDeviceNo] = useState('');
    const [plate, setPlate] = useState('');
    const [vehicleTypeId, setVehicleTypeId] = useState('');
    const [file, setFile] = useState<File | undefined>(undefined);

    const onCustomClose = (_state: boolean) => {
        if (onClose && _state)
            onClose();

        dispatch(storeAreYouSureModalCallback(undefined));
    }

    return (
        <Modal
            id='kt_modal_create_app'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-900px'
            show={isShown}
            onHide={() => onCustomClose(false)}
            backdrop={'static'}
            keyboard={false}
        >
            <div className='modal-body'>
                <h1>Emin Misiniz?</h1>
                <h3>Yaptığınız işlem geri alınayamacaktır.</h3>
            </div>

            <div className="modal-footer">
                <button
                    onClick={() => onCustomClose(false)}
                    type="button"
                    className="btn btn-danger"
                >
                    Hayır
                </button>
                <button onClick={() => onCustomClose(true)} type="button" className="btn btn-success">
                    Evet
                </button>
            </div>
        </Modal >
    )
}

export default AreYouSureModal;